/**
 * Metafield color swatches (custom.colors).
 * With a Color variant option: also syncs to that option.
 * Without one: selection is submitted as properties[Color] via radio inputs.
 */
(function () {
  function getProductForm(element) {
    return element.closest(".ProductForm") || element.closest('form[action*="/cart/add"]');
  }

  function syncMetafieldColorLabel(container, colorName) {
    if (!container || !colorName) return;

    var selectedLabel = container.querySelector("[data-metafield-color-selected]");
    if (selectedLabel) {
      selectedLabel.textContent = colorName;
    }

    var matched = false;

    container.querySelectorAll(".MetafieldColorSwatch__Radio").forEach(function (radio) {
      var label = radio.nextElementSibling;
      var isActive = radio.value === colorName;

      if (isActive) {
        matched = true;
      }

      radio.checked = isActive;

      if (label && label.classList.contains("ColorSwatch")) {
        label.classList.toggle("is-active", isActive);
      }
    });

    if (!matched) {
      var firstRadio = container.querySelector(".MetafieldColorSwatch__Radio");
      if (firstRadio) {
        firstRadio.checked = true;
        var firstLabel = firstRadio.nextElementSibling;
        if (firstLabel && firstLabel.classList.contains("ColorSwatch")) {
          firstLabel.classList.add("is-active");
        }
        if (selectedLabel) {
          selectedLabel.textContent = firstRadio.value;
        }
      }
    }
  }

  function selectColorOption(form, optionPosition, colorName) {
    if (!form || !optionPosition || !colorName) return;

    var radios = form.querySelectorAll(
      '.ColorSwatch__Radio[data-option-position="' + optionPosition + '"]'
    );

    radios.forEach(function (radio) {
      if (radio.value === colorName && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }

  function handleMetafieldColorChange(input) {
    var container = input.closest(".ProductForm__MetafieldColors");
    if (!container) return;

    var form = getProductForm(input);
    var colorName = input.value;

    syncMetafieldColorLabel(container, colorName);

    var optionPosition = container.getAttribute("data-color-option-position");
    if (optionPosition) {
      selectColorOption(form, optionPosition, colorName);
    }
  }

  document.addEventListener("change", function (event) {
    var input = event.target;
    if (!input.matches(".MetafieldColorSwatch__Radio")) return;
    handleMetafieldColorChange(input);
  });

  document.addEventListener("variant:changed", function (event) {
    var form = event.target.closest ? event.target.closest(".ProductForm") : null;
    if (!form) return;

    var container = form.querySelector(".ProductForm__MetafieldColors");
    if (!container) return;

    var optionPosition = container.getAttribute("data-color-option-position");
    if (!optionPosition) return;

    var checkedRadio = form.querySelector(
      '.ColorSwatch__Radio[data-option-position="' + optionPosition + '"]:checked'
    );

    if (!checkedRadio) return;

    var metafieldRadios = container.querySelectorAll(".MetafieldColorSwatch__Radio");

    metafieldRadios.forEach(function (radio) {
      if (radio.value === checkedRadio.value) {
        syncMetafieldColorLabel(container, radio.value);
      }
    });
  });

  function initMetafieldColorForms() {
    document.querySelectorAll(".ProductForm__MetafieldColors").forEach(function (container) {
      var checkedRadio = container.querySelector(".MetafieldColorSwatch__Radio:checked");

      if (!checkedRadio) {
        checkedRadio = container.querySelector(".MetafieldColorSwatch__Radio");
        if (checkedRadio) {
          checkedRadio.checked = true;
        }
      }

      if (checkedRadio) {
        handleMetafieldColorChange(checkedRadio);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initMetafieldColorForms);
  } else {
    initMetafieldColorForms();
  }
})();

(() => {
  function initProductBuying(section) {
    const form = section.querySelector('.product-info form.ProductForm');
    const primary = form?.querySelector('.ProductForm__AddToCart');
    const sticky = section.querySelector('.sticky-product');
    const action = sticky?.querySelector('[data-jd-sticky-cart]');
    if (!primary || !action || action.dataset.jdReady) return;
    action.dataset.jdReady = 'true';
    const priceList = form.querySelector('.ProductMeta__PriceList');
    const price = sticky.querySelector('.sticky-price-main');
    const compare = sticky.querySelector('.sticky-price-old');
    function sync() {
      action.disabled = primary.disabled;
      action.textContent = primary.textContent.trim();
      const current = priceList?.querySelector('.ProductMeta__Price:not(.Price--compareAt)');
      const previous = priceList?.querySelector('.Price--compareAt');
      if (current) price.textContent = current.textContent;
      compare.textContent = previous?.textContent || '';
      compare.hidden = !previous;
    }
    function visibility() {
      sticky.classList.toggle('fixed', primary.getBoundingClientRect().bottom < 0);
    }
    action.addEventListener('click', () => {
      sync();
      if (primary.disabled) return;
      primary.focus({preventScroll: true});
      primary.click();
    });
    new MutationObserver(sync).observe(primary, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled']});
    if (priceList) new MutationObserver(sync).observe(priceList, {subtree: true, childList: true, characterData: true});
    section.addEventListener('variant:changed', sync);
    window.addEventListener('scroll', visibility, {passive: true});
    window.addEventListener('resize', visibility);
    sync();
    visibility();
  }
  function init(root) {
    if (root.matches?.('.product-main')) initProductBuying(root);
    root.querySelectorAll('.product-main').forEach(initProductBuying);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
